import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Check, Loader2 } from "lucide-react";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMessage("Missing verification token."); return; }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => {
        setState("ok");
        setMessage(data.already_verified ? "Your email is already verified." : "Email confirmed. Welcome to Reads.");
      })
      .catch((e) => { setState("error"); setMessage(formatApiError(e)); });
  }, [token]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="verify-email-page">
      <div className="max-w-md w-full border border-[rgba(10,10,10,0.10)] bg-[#FAF5E6] p-10 text-center">
        <div className="font-mono uppercase tracking-[0.25em] text-xs text-[#525252]">Email verification</div>
        <h1 className="font-heading text-4xl text-[#0A0A0A] mt-3">
          {state === "loading" && "Checking your link…"}
          {state === "ok" && "All set."}
          {state === "error" && "We couldn't confirm that link."}
        </h1>
        <div className="mt-6 flex items-center justify-center">
          {state === "loading" && <Loader2 className="w-6 h-6 animate-spin text-[#0A0A0A]" strokeWidth={1.5} />}
          {state === "ok" && <Check className="w-6 h-6 text-[#0A0A0A]" strokeWidth={1.5} />}
        </div>
        {message && <p className="mt-6 text-sm text-[#525252]" data-testid="verify-message">{message}</p>}
        <Link to="/" className="inline-block mt-8 font-mono uppercase tracking-widest text-xs text-[#0A0A0A] hover:underline" data-testid="verify-home-link">
          Continue to Reads →
        </Link>
      </div>
    </div>
  );
}
